X-Content-Type-Options: nosniff

<template>
  <!-- 轮播图 -->
  <div class="list_one">
    <!-- 导航栏 -->
    <div class="top">
      <CrmHeader></CrmHeader>
    </div>
    <!-- 轮播 -->
    <el-carousel direction="horizontal" height="100vh" indicator-position="none" arrow="never" ref="cardShow" :interval="8000">
      <el-carousel-item class="swpier_box" v-for="(item,index) in Indeexbanner" :key="index" :label="index">
        <img class="imgs" mode="widthFix" :src="item" alt="">
      </el-carousel-item>
    </el-carousel>

    <!-- 翻页按钮 -->
    <div class="one_bottom">
      <div class="four_btn" @click="arrowClick('left')">
        <img class="imgs" src="../assets/images/left_ic.png" alt="">
      </div>
      <div class="four_btn" @click="arrowClick('right')">
        <img class="imgs" src="../assets/images/right_ico.png" alt="">
      </div>
    </div>

  </div>
</template>

<script>
// 引用组件
import Vue from "vue";
import $ from "jquery";

$.ajaxSetup({
  timeout: 30000000 // 设置默认超时时间为30秒
});


export default {
  name: ``,

  data () {
    return {


      timeOut: null,
      numbrt: '',

      Zylistdata: [], //专家列表
      RyList: [], //企业荣誉
      GyList: [], //公益活动
      Indeexbanner: [], //首页banner
    }
  },



  created: function () {
    this.getIndexBanner()
  },



  methods: {
    // 第一页按钮
    arrowClick (val) {
      if (val === 'right') {
        this.$refs.cardShow.next()
      } else {
        this.$refs.cardShow.prev()
      }
    },


    // 首页banner
    getIndexBanner () {
      $.ajax({
        url: this.$baseUrl + "queryBanner/100000",
        type: "get",
        contentType: false, //multipart/form-data
        cache: true, //是否缓存，推荐使用。用于性能优化，减少http请求
        dataType: "json",
        timeout: 9999999999, 
        success: (res, statusTest, xhr) => {
          console.log(res)
          this.Indeexbanner = res.data
        }

      })

    },
  }
}
</script>

<style>
.index_box {
  display: table-cell;
  vertical-align: middle;
  width: 100%;
  height: 100vh;
  border: 1px solid red;
}

.box {
  width: 100%;
  height: 100vh;
  /*   background-color: #ccc; */
  border: 1px solid rebeccapurple;
}

.top {
  width: 100%;
  position: absolute;
  top: 0;
  z-index: 10000;
}

.list_box {
  width: 100%;
  height: 100vh !important;
}

.list_box /deep/.el-carousel__container {
  width: 100%;
  height: 100vh !important;
}

.swpier_box {
  width: 100%;
  height: 100vh !important;
}

.imgs {
  width: 100%;
  height: 100%;
  display: inline-block !important;
}

.font {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 第一页 */
.list_one {
  width: 100%;
  height: 100vh;
}

.one_bottom {
  display: flex;
  flex-direction: row;
  position: absolute;
  z-index: 10000;
  bottom: 0%;
  right: 0%;
}

.four_btn {
  width: 123px;
  height: 62px;
}
</style>



// WEBPACK FOOTER //
// src/components/indexOne.vue